import { useRef, useCallback } from 'react';

export function useAudioPlayer() {
  const audioRef = useRef(null);

  const play = useCallback((audioUrl) => {
    if (audioRef.current) {
      audioRef.current.pause();
    }
    const audio = new Audio(audioUrl);
    audioRef.current = audio;
    audio.play().catch((e) => console.error('Audio play error:', e));
    return audio;
  }, []);

  const stop = useCallback(() => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
  }, []);

  return { play, stop };
}

export function useSpeechRecognition(language = 'en') {
  const recognitionRef = useRef(null);

  const startListening = useCallback(
    (onResult, onEnd) => {
      const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
      if (!SpeechRecognition) {
        console.error('Speech recognition not supported');
        return false;
      }

      const recognition = new SpeechRecognition();
      recognition.lang = language === 'de' ? 'de-DE' : 'en-US';
      recognition.interimResults = false;
      recognition.maxAlternatives = 1;

      recognition.onresult = (event) => {
        const transcript = event.results[0][0].transcript;
        onResult(transcript);
      };

      recognition.onend = () => {
        onEnd?.();
      };

      recognition.onerror = (event) => {
        console.error('Speech recognition error:', event.error);
        onEnd?.();
      };

      recognitionRef.current = recognition;
      recognition.start();
      return true;
    },
    [language]
  );

  const stopListening = useCallback(() => {
    if (recognitionRef.current) {
      recognitionRef.current.stop();
    }
  }, []);

  return { startListening, stopListening };
}
